export const getErrorMessage = ({ response }) => {
  let message = 'Ops! Ocorreu um problema no sistema';
  console.log(response);
  if (response) {
    const {
      data: { error },
    } = response;
    if (error) {
      message = error;
    }
  }
  return message;
};
